<template>
  <div class="flex flex-wrap gap-2">
    <NBadge label="v1.2.0" icon="i-heroicons-sparkles-solid text-primary" class="rounded-full" />

    <NBadge badge="soft-gray" label="Offline" icon="i-tabler-circle-filled text-7px text-gray" />

    <NBadge badge="soft-gray" label="Online" icon="i-tabler-circle-filled text-7px text-green" />
  </div>
</template>
